import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import About from './pages/About';
import Resume from './pages/Resume';
import Portfolio from './pages/Portfolio';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import CertificateVerify from './pages/CertificateVerify';

function App() {
  const isVerifyPage = window.location.pathname.replace(/\/+$/, '') === '/verify';
  const [activeSection, setActiveSection] = useState('about');
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const navigateToSection = (sectionId) => {
    setActiveSection(sectionId);
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  if (isVerifyPage) {
    return <CertificateVerify />;
  }

  const renderCurrentSection = () => {
    switch (activeSection) {
      case 'about':
        return <About />;
      case 'resume':
        return <Resume />;
      case 'portfolio':
        return <Portfolio />;
      case 'blog':
        return <Blog />;
      case 'contact':
        return <Contact />;
      default:
        return <About />;
    }
  };

  return (
    <div className="min-h-screen bg-bg-dark text-white-1">
      <div className="flex">
        {/* Sidebar */}
        <Sidebar 
          darkMode={darkMode} 
          toggleDarkMode={toggleDarkMode}
        />

        {/* Main Content */}
        <main className="flex-1 lg:ml-80">
          {/* Mobile Navbar */}
          <Navbar 
            activeSection={activeSection}
            navigateToSection={navigateToSection}
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
          />

          {/* Desktop Tab Navigation */}
          <div className="hidden lg:block bg-card-dark/30 border-b border-white-1/5">
            <div className="px-4 lg:px-8 py-4 max-w-7xl mx-auto">
              <div className="flex space-x-6">
                {['about', 'resume', 'portfolio', 'blog', 'contact'].map((section) => (
                  <button
                    key={section}
                    onClick={() => navigateToSection(section)}
                    className={`relative px-3 py-2 font-medium capitalize transition-all duration-300 text-sm ${
                      activeSection === section
                        ? 'text-accent-yellow'
                        : 'text-white-1/60 hover:text-white-1'
                    }`}
                  >
                    {section}
                    {activeSection === section && (
                      <motion.div
                        className="absolute bottom-0 left-0 right-0 h-0.5 bg-accent-yellow"
                        layoutId="activeTab"
                        transition={{ type: "spring", stiffness: 300, damping: 30 }}
                      />
                    )}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Page Content - Single section display */}
          <div className="p-4 lg:p-8 min-h-screen max-w-7xl mx-auto">
            <motion.div
              key={activeSection}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              {renderCurrentSection()}
            </motion.div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
